/**
 * EntitySummaryCard — renders an EntitySummary tool result.
 * [Source: Story P1b spec §8]
 */
import type { EntitySummary } from '@brokly/shared';
import { Card } from '../../../components/ui/Card';
import { Badge } from '../../../components/ui/Badge';

interface Props {
  data: EntitySummary;
}

export function EntitySummaryCard({ data }: Props) {
  if (!data.found) {
    return (
      <Card className="p-3 text-sm text-muted-foreground">Nichts gefunden.</Card>
    );
  }

  if (data.entityType === 'kunde') {
    return (
      <Card className="p-3 text-sm">
        <div className="mb-1 font-medium">{data.name}</div>
        <div className="space-y-0.5 text-xs text-muted-foreground">
          {data.uid && <div>UID: {data.uid}</div>}
          {data.canton && <div>Kanton: {data.canton}</div>}
          {data.status && <Badge variant="neutral">{data.status}</Badge>}
        </div>
      </Card>
    );
  }

  if (data.entityType === 'police') {
    return (
      <Card className="p-3 text-sm">
        <div className="mb-1 font-medium">{data.policyNumber ?? data.id}</div>
        <div className="space-y-0.5 text-xs text-muted-foreground">
          {data.versicherer && <div>Versicherer: {data.versicherer}</div>}
          {data.sparte && <div>Sparte: {data.sparte}</div>}
          {data.renewalDate && <div>Renewal: {data.renewalDate}</div>}
          {data.status && <Badge variant="neutral">{data.status}</Badge>}
        </div>
      </Card>
    );
  }

  return null;
}
